// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2tsu8","unreadBadge":"styles_unreadBadge__1TGpi","modalContent":"styles_modalContent__2M7eR","modal":"styles_modal__12Rqf"};